import type { ReactNode } from 'react';

export const symbol_language_us_dvorak: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-340h150v-280H220v280Zm-30 60q-12.75 0-21.37-8.63Q160-297.25 160-310v-340q0-12.75 8.63-21.38Q177.25-680 190-680h180q24.75 0 42.38 17.62Q430-644.75 430-620v280q0 24.75-17.62 42.37Q394.75-280 370-280H190Zm466.11 0q-10.11 0-18.03-6.06-7.91-6.06-11.08-14.94L507-643q-5-14 3.35-25.5t23.54-11.5q9.11 0 16.61 5.48T561-661l107 300 106-300q3-8.04 10.5-13.52T801-680q14 0 23 12t4 26L707-301q-3.22 8.88-11.28 14.94Q687.67-280 678-280h-21.89Z"
		/>
	</svg>
);
